import { put, takeEvery, fork } from 'redux-saga/effects';
import { ErrorTypes } from 'constants/errorTypes';
import { TrialRegion } from 'types/TrialRegion';
import trialRegionActionsCreators from '../actions/trialRegions/actions';
import { SagaType, SagaWatcherType, SagaWorkerType} from './types';
import {
  TrialRegionActionType,
} from '../actions/trialRegions/types/actions';
import buildMockTrialRegion from '../mocks/trialBlock/buildMockTrialBlock.json'

const {
  fetchTrialRegionsResolved,
  fetchTrialRegionsRejected,
} = trialRegionActionsCreators;

export function* trialRegionWorker(): SagaWorkerType<TrialRegion> {
  try {
    const mockedData = buildMockTrialRegion;

    yield put(
      fetchTrialRegionsResolved(mockedData)
    );
  } catch (e) {
    const error = e as Error;
    yield put(fetchTrialRegionsRejected(error.message as ErrorTypes));
  }
}


export function* trialRegionsWatcher(): SagaWatcherType {
  yield takeEvery(TrialRegionActionType.FetchTrialRegions, trialRegionWorker);
}

export default function* trialRegionSaga(): SagaType {
  yield fork(trialRegionsWatcher);
}
